export function isXssSafe(input: string): boolean {
    // XSS regex pattern (case-insensitive)
    const pattern = /(<[^>]+>)|(<script.*?>.*?<\/script>)|(on[a-zA-Z]+\s*=\s*['"])/i;
    return !pattern.test(input);
}
